<template>
  <div>
    <TablePublic :colLists="pickProcessColLists" :tableData="[formData]" :paginationFlag="false">
      <template slot="solts" slot-scope="scope">
        <el-button @click="toWeightRecord(scope.data)" type="text" size="small" class="button">称重记录</el-button>
      </template>
    </TablePublic>

    <Mdialog
      title="称重记录"
      :visible.sync="weightDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="closeWeightDialog"
    >
      <WeightRecord :data="formData.weighRespList" />
    </Mdialog>

  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import WeightRecord from './WeightRecord'

export default {
  name: 'Weight',
  components: {
    TablePublic,
    Mdialog,
    WeightRecord,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const _this = this
    return {
      weightDialog: false,
      pickProcessColLists: [
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecAttrKey',
          label: '规格',
          isTrue: true,
          formatter() {
            const arr = [
              _this.formData.ripenessLevelSpecAttrValueKey,
              _this.formData.locDetails?.slice(_this.formData.locDetails?.lastIndexOf(',') + 1),
              _this.formData.cultivationMethodSpecValueKey,
            ]

            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'actualTotalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'totalTailContainerWeight',
          label: '尾筐总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'actualTotalNetWeight',
          label: '采摘总净重（斤）',
          isTrue: true,
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
    }
  },
  mounted() {},
  methods: {
    closeWeightDialog() {
      this.weightDialog = false
    },
    toWeightRecord() {
      this.weightDialog = true
    },
  },
}
</script>

<style scoped lang="less">
</style>
